import { loc } from '@/localization';
import { discoveryService } from '@/services/instance/discovery';
import { useDriftLoader } from '@/site/components/DriftLoader/provider';

import chatIcon from './assets/chat.svg';
import contactsIcon from './assets/contacts.svg';
import helpIcon from './assets/help.svg';
import { b, e } from './style.css';

const siteUrl = discoveryService.get('site');

function HelpMenuItem(props: HelpMenuItem.Props) {
    const { description, href, icon, onClick, title } = props;

    const Component = href ? 'a' : 'div';

    return (
        <div className={b.name}>
            <Component
                href={href}
                onClick={onClick}
                target="_blank"
                className={e.link}
            >
                <img
                    className={e.icon}
                    src={icon}
                    alt={title}
                />
                <div className={e.linkText}>
                    <p className={e.title}>{title}</p>
                    {description && <p className={e.description}>{description}</p>}
                </div>
            </Component>
        </div>
    );
}

namespace HelpMenuItem {
    export interface Props {
        icon: string;
        title: string;
        description?: string;
        href?: string;
        onClick?: () => void;
    }
}

export const HelpMenuItemHelp = ({ helpLink }: { helpLink?: string }) => (
    <HelpMenuItem
        title={loc.Main.HelpMenuHelpCenter}
        description={loc.Main.HelpMenuHelpCenterDescription}
        icon={helpIcon}
        href={helpLink ?? `${siteUrl}help`}
    />
);

export const HelpMenuItemContacts = () => (
    <HelpMenuItem
        title={loc.Main.HelpMenuSupport}
        description={loc.Main.HelpMenuSupportDescription}
        icon={contactsIcon}
        href={`${siteUrl}contacts?contact-form=support`}
    />
);

export const HelpMenuItemChat = () => {
    const [, openChat] = useDriftLoader();

    return (
        <HelpMenuItem
            title={loc.Main.HelpMenuChat}
            description={loc.Main.HelpMenuChatDescription}
            icon={chatIcon}
            onClick={openChat}
        />
    );
};
